var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-banner',{attrs:{"width":"100%","color":"#0089B5","rounded":"","dark":""}},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }